import React, { useState } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

//--- layouts & components ---
import LoginLayout from '../../layout/LoginLayout'
import LeftImageComponent from '../../components/CommonComponents/LeftImageComponent'
import Image from '../../assets/img/signin.png'
import { BsEye, BsEyeSlash } from "react-icons/bs";
import {RiErrorWarningLine } from 'react-icons/ri'
import { doResetPassword } from '../../redux/actions/auth'

const ResetPassword = () => {
    const dispatch = useDispatch()
    const { email, hash } = useParams()
    const [isReset, setIsResetPassword] = useState(false)
    const [newpasswordvalues, setNewPassword] = useState({
        password: '',
        showPassword: false,
        newPwdError : ''
    }
    )
    const [confirmpasswordvalues, setConfirmPassword] = useState({
        confirmpassword: '',
        showPassword: false,
        confirmPwdError : ''
    })

    const onResetPassword = () => {
        if (!newpasswordvalues.password) {
          newpasswordvalues.newPwdError = 'New Password should not be empty!'
        } else {
          newpasswordvalues.newPwdError = ''
        }
        if (!confirmpasswordvalues.confirmpassword) {
          confirmpasswordvalues.confirmPwdError = 'Confirm Password should not be empty!'
        } else {
          confirmpasswordvalues.confirmPwdError = ''
        }
        if (confirmpasswordvalues.confirmpassword !== newpasswordvalues.password) {
          confirmpasswordvalues.confirmPwdError = 'Confirm Password must be same as new password!'
        } else {
          confirmpasswordvalues.confirmPwdError = ''
        }
        if (newpasswordvalues.newPwdError === '' && confirmpasswordvalues.confirmPwdError === '') {
          dispatch(
            doResetPassword({
              email,
              hash,
              password: newpasswordvalues.password,
            })
          ).then(() => {
            setIsResetPassword(true)
          }).catch(() => {
            setIsResetPassword(false)
          })
        } else {
          setNewPassword({...newpasswordvalues})
          setConfirmPassword({...confirmpasswordvalues})
        }
    }

    if (isReset) {
      return <Redirect to='/login' />
    }

    const handleClickShowPassword = (prop) => {
      if(prop === 'confirmpassword') {
        setConfirmPassword({ ...confirmpasswordvalues, showPassword: !confirmpasswordvalues.showPassword });
      } else {
        setNewPassword({ ...newpasswordvalues, showPassword: !newpasswordvalues.showPassword });
      }
    }

    const handlePasswordChange = (prop) => (event) => {
        if(prop === 'confirmpassword') {
          if (confirmpasswordvalues.confirmpassword) {
            confirmpasswordvalues.confirmPwdError = ''
          }
          setConfirmPassword({ ...confirmpasswordvalues, [prop]: event.target.value });
        } else {
          if (newpasswordvalues.password) {
            newpasswordvalues.newPwdError = ''
          }
          setNewPassword({ ...newpasswordvalues, [prop]: event.target.value });
        }
    };

  return (
    <LoginLayout>
      <div className="reset-password-page flex-sm-column flex-column flex-lg-row">
        <div className='reset-password-left'>
          <LeftImageComponent image={Image} quote="A User Friendly Software with Exceptional Customer Support" quoteby="-Kristi H, Denver, US"/>
        </div>
        <div className={`reset-password-right `}>
            <div className="form-content">
                <div className="form-title">
                  <h4>Reset your Password?</h4>
                  <span>Enter your new password which should be different form previous used passwords.</span>
                </div>
                <div className="form-input-container">
                  <div className={`form-input-inner ${newpasswordvalues.newPwdError ? '' : 'has-bottom-margin'}`}>
                    <div className="form-input">
                      <input className={`${newpasswordvalues.newPwdError ? 'error-border' : ''}`} type={newpasswordvalues.showPassword ? "text" : "password"} placeholder="New Password" value={newpasswordvalues.password} onChange={handlePasswordChange("password")}/>
                      {newpasswordvalues.showPassword ? 
                          <BsEye color="#104569" size={24} onClick={() => handleClickShowPassword('newpassword')}/> 
                          :
                          <BsEyeSlash color="#104569" size={24} onClick={() => handleClickShowPassword('newpassword')}/>
                      }
                    </div>
                    {newpasswordvalues.newPwdError && (
                      <div className='error-container flex align-center'>
                        <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                        <p className='error mb-2'>{newpasswordvalues.newPwdError}</p>
                      </div>
                    )}
                  </div>
                  <div className={`form-input-inner ${confirmpasswordvalues.confirmPwdError ? '' : 'has-bottom-margin'}`}>
                    <div className="form-input">
                      <input className={`${confirmpasswordvalues.confirmPwdError ? 'error-border' : ''}`} type={confirmpasswordvalues.showPassword ? "text" : "password"} placeholder="Confirm Password" value={confirmpasswordvalues.confirmpassword} onChange={handlePasswordChange("confirmpassword")}/>
                      {confirmpasswordvalues.showPassword ? 
                          <BsEye color="#104569" size={24} onClick={() => handleClickShowPassword('confirmpassword')}/>
                          :
                          <BsEyeSlash color="#104569" size={24} onClick={() => handleClickShowPassword('confirmpassword')}/>
                      }
                    </div>
                    {confirmpasswordvalues.confirmPwdError && (
                      <div className='error-container flex align-center'>
                        <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                        <p className='error mb-2'>{confirmpasswordvalues.confirmPwdError}</p>
                      </div>
                    )}
                  </div>
                  
                  <button type="button" className="btn-login" onClick={onResetPassword}>Reset Password</button>
                </div>
            </div>
          <div className='privacy-copyright-container d-flex justify-content-between h-100 w-100 align-items-end'>
            <span className='h3'> Privacy Policy </span>
            <span className='h3'> Copyright 2022 </span>
          </div>
        </div>
      </div>
    </LoginLayout>
  )
}

export default ResetPassword
